<!-- <div class="pdfContain" style="width: 15cm; position: absolute; left: -1000px; top: 0;">-->
<div class="pdfContain" style="margin: 0 auto; width: 14cm; border:1px solid #e9e9e9; position: fixed; left: -1000px; top: 0;">
    <kendo-pdf-export #pdf margin="1cm" paperSize="A4" [repeatHeaders]="repeatHeaders">
        <div class="a4Width pdf-content" id="mytable">
            <table class="table">
                <tbody style="background-color: white;">
                    <div class="col-12 pr-4">
                        <div class="row">
                            <div #filterDetails>
                                <div class="mt-2 col-12 d-flex" style="width: 14cm">
                                    <div class="col p-0" *ngIf="SOPName">
                                        <label>{{ 'EVALUATION.SOP' | translate }}</label>
                                        <div>{{SOPName | translate | labelSanitizer}}</div>
                                    </div>

                                    <div class="col p-0" *ngIf="!SOPName  && !isObserve">
                                        <!--CONLFICT &&!isObserve condidion was only present on phase2 code-->
                                        <label>{{ 'EVALUATION.SOP' | translate }}</label>
                                        <ul>
                                            <li *ngFor="let step of SOPList"> {{ step.title | translate | labelSanitizer}}</li>
                                        </ul>
                                    </div>

                                    <div class="col p-0" *ngIf="Steps">
                                        <label>{{ 'EVALUATION.STEPS' | translate }}</label>
                                        <div>{{Steps | translate | labelSanitizer}}</div>
                                    </div>

                                    <div class="col p-0" *ngIf="specificStep">
                                        <label>{{ 'EVALUATION.SPECIFIC_STEPS' | translate }}</label>
                                        <div>
                                            <ul>
                                                <li *ngFor="let step of specificStep"> {{ step.stepTittle | translate | labelSanitizer}}</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                                <div class="mt-2 col-12 d-flex">
                                    <div #filter *ngIf="showFilter">
                                        <label>{{ 'EVALUATION.FILTER' | translate }} {{"01"}}</label>
                                        <div>
                                          <span>{{ dateRangeFormatted }}</span>
                                        </div>
                                        <div>
                                            <span class="resultBox" *ngIf="setCountry && roleId == 1">{{setCountry.countryName | translate}}
                      </span>
                                            <span class="resultBox" *ngIf="!setCountry && roleId == 1">{{ 'EVALUATION.All.COUNTRIES' | translate }} </span>
                                            <span class="resultBox" *ngIf="setInstitution">{{setInstitution.institutionName | labelSanitizer}}</span>
                                            <span class="resultBox" *ngIf="!setInstitution">{{ 'EVALUATION.All.INSTITUTIONS' | translate }}
                      </span>
                                            <span class="resultBox" *ngIf="setWard">{{setWard.wardName | translate | labelSanitizer}} </span>
                                            <span class="resultBox" *ngIf="!setWard">{{ 'EVALUATION.All.WARDS' | translate }} </span>
                                            <span class="resultBox" *ngIf="setDepartment">{{setDepartment.departmentName | translate | labelSanitizer}} </span>
                                            <span class="resultBox" *ngIf="!setDepartment">{{ 'EVALUATION.All.DEPARTMENTS' | translate }}
                      </span>
                                            <span class="resultBox" *ngIf="setCategory">{{setCategory.categoryName | translate | labelSanitizer}}</span>
                                            <span class="resultBox" *ngIf="!setCategory">{{ 'EVALUATION.All.PROFESSIONAL_CATEGORIES' | translate }} </span>

                                            <div *ngIf="showProfessionalSubcategory">
                                                <span class="resultBox" *ngIf="setSubCategory">{{setSubCategory.subCategoryName | translate | labelSanitizer}}
                      </span>
                                                <span class="resultBox" *ngIf="!setCategory">{{ 'EVALUATION.All.PROFESSIONAL_SUB_CATEGORIES' | translate }}
                      </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="mt-2 col-12 d-flex" *ngIf="showCompareCard">
                                    <div #filter2>
                                        <label>{{ 'EVALUATION.FILTER' | translate }} {{"02"}}</label>
                                        <div>
                                          <span>{{ dateRange2Formatted }}</span>
                                        </div>
                                        <div>
                                            <span class="resultBox" *ngIf="setCountry2 && roleId == 1">{{setCountry2.countryName | translate}}
                      </span>
                                            <span class="resultBox" *ngIf="!setCountry2 && roleId == 1">{{ 'EVALUATION.All.COUNTRIES' | translate }}
                      </span>
                                            <span class="resultBox" *ngIf="setInstitution2">{{setInstitution2.institutionName | labelSanitizer}}</span>
                                            <span class="resultBox" *ngIf="!setInstitution2">{{ 'EVALUATION.All.INSTITUTIONS' | translate }}
                      </span>
                                            <span class="resultBox" *ngIf="setWard2">{{setWard2.wardName | translate | labelSanitizer}} </span>
                                            <span class="resultBox" *ngIf="!setWard2">{{ 'EVALUATION.All.WARDS' | translate }} </span>
                                            <span class="resultBox" *ngIf="setDepartment2">{{setDepartment2.departmentName | translate | labelSanitizer}}
                      </span>
                                            <span class="resultBox" *ngIf="!setDepartment2">{{ 'EVALUATION.All.DEPARTMENTS' | translate }}
                      </span>
                                            <span class="resultBox" *ngIf="setCategory2">{{setCategory2.categoryName | translate | labelSanitizer}}</span>
                                            <span class="resultBox" *ngIf="!setCategory2">{{ 'EVALUATION.All.PROFESSIONAL_CATEGORIES' | translate }}
                      </span>
                                            <div *ngIf="showProfessionalSubcategory">
                                                <span class="resultBox" *ngIf="setSubCategory2">{{setSubCategory2.subCategoryName | translate | labelSanitizer}}
                      </span>
                                                <span class="resultBox" *ngIf="!setCategory2">{{ 'EVALUATION.All.PROFESSIONAL_SUB_CATEGORIES' | translate }}
                      </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="mt-2" style="display: none;">
                                    <div class="row">
                                        <div class="col-md-5 col-sm-12" *ngIf="SOPName">
                                            <div class="form-group">
                                                <label>{{ 'EVALUATION.SOP' | translate }}</label>
                                                <span>{{SOPName | labelSanitizer}}</span>
                                            </div>
                                        </div>
                                        <div class="col-md-3 col-sm-12" *ngIf="Steps">
                                            <div class="form-group">
                                                <label>{{ 'EVALUATION.STEPS' | translate }}</label>
                                                <span>{{Steps | labelSanitizer}}</span>
                                            </div>
                                        </div>
                                        <div class="col-md-4 col-sm-12" *ngIf="specificStep">
                                            <div class="form-group multiselect-container">
                                                <div class="multiselect-top d-flex justify-content-between">
                                                  <label>{{ "EVALUATION.SPECIFIC_STEPS" | translate }}</label>
                                                  <button class="multiselect-clear" (click)="multiselect.reset();">
                                                    <img src="assets/icons/closeOutlined.svg" />
                                                  </button>
                                                </div>
                                                <div class="multiselect-div">
                                                    <kendo-multiselect #multiselect [data]="specificStep" [textField]="'stepTittle'" [valueField]="'stepTittle'" [autoClose]="false" placeholder="{{ 'EVALUATION.All.STEPS' | translate }}">
                                                        <ng-template kendoMultiSelectItemTemplate let-dataItem>
                                                            <input type="checkbox" class="k-checkbox"> {{ dataItem.stepTittle | translate | labelSanitizer}}
                                                        </ng-template>
                                                    </kendo-multiselect>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div #filter *ngIf="showFilter" style="display: none;">
                                    <div class="col-12 static-card sub-step-card">
                                        <h1>{{'GENERAL.FILTER_ONE' | translate}} </h1>
                                        <div class="row">
                                            <div class="col-md-4 col-lg-4 col-sm-12">
                                                <div class="form-group">
                                                  <span>{{ dateRangeFormatted }}</span>
                                                </div>
                                            </div>
                                            <div class="col-md-8 col-lg-8 col-sm-12">
                                                <div>
                                                    <span class="resultBox" *ngIf="setCountry && roleId == 1">{{setCountry.countryName | translate | labelSanitizer}} </span>
                                                    <span class="resultBox" *ngIf="!setCountry && roleId == 1">{{ 'EVALUATION.All.COUNTRIES' | translate }}
                          </span>
                                                    <span class="resultBox" *ngIf="setInstitution">{{setInstitution.institutionName | labelSanitizer}}</span>
                                                    <span class="resultBox" *ngIf="!setInstitution">{{ 'EVALUATION.All.INSTITUTIONS' | translate }} </span>
                                                    <span class="resultBox" *ngIf="setWard">{{setWard.wardName | translate | labelSanitizer}} </span>
                                                    <span class="resultBox" *ngIf="!setWard">{{ 'EVALUATION.All.WARDS' | translate }} </span>
                                                    <span class="resultBox" *ngIf="setDepartment">{{setDepartment.departmentName | translate | labelSanitizer}}
                          </span>
                                                    <span class="resultBox" *ngIf="!setDepartment">{{ 'EVALUATION.All.DEPARTMENTS' | translate }}
                          </span>
                                                    <span class="resultBox" *ngIf="setCategory">{{setCategory.categoryName | translate | labelSanitizer}}</span>
                                                    <span class="resultBox" *ngIf="!setCategory">{{ 'EVALUATION.All.PROFESSIONAL_CATEGORIES' | translate }}
                          </span>
                                                    <div *ngIf="showProfessionalSubcategory">
                                                        <span class="resultBox" *ngIf="setSubCategory">{{setSubCategory.subCategoryName | translate | labelSanitizer}}
                          </span>
                                                        <span class="resultBox" *ngIf="!setCategory">{{ 'EVALUATION.All.PROFESSIONAL_SUB_CATEGORIES' | translate }}
                          </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div #filter2 *ngIf="showCompareCard" style="display: none;">
                                    <div class="col-12 static-card sub-step-card">
                                        <h1>{{'GENERAL.FILTER_TWO' | translate}} </h1>
                                        <div class="row">
                                            <div class="col-md-4 col-lg-4 col-sm-12">
                                                <div class="form-group">
                                                  <span>{{ dateRange2Formatted }}</span>
                                                </div>
                                            </div>
                                            <div class="col-md-8 col-lg-8 col-sm-12">
                                                <div>
                                                    <span class="resultBox" *ngIf="setCountry2 && roleId == 1">{{setCountry2.countryName | translate | labelSanitizer}} </span>
                                                    <span class="resultBox" *ngIf="!setCountry2 && roleId == 1">{{ 'EVALUATION.All.COUNTRIES' | translate }}
                          </span>
                                                    <span class="resultBox" *ngIf="setInstitution2">{{setInstitution2.institutionName | labelSanitizer}}</span>
                                                    <span class="resultBox" *ngIf="!setInstitution2">{{ 'EVALUATION.All.INSTITUTIONS' | translate }} </span>
                                                    <span class="resultBox" *ngIf="setWard2">{{setWard2.wardName | translate | labelSanitizer}} </span>
                                                    <span class="resultBox" *ngIf="!setWard2">{{ 'EVALUATION.All.WARDS' | translate }} </span>
                                                    <span class="resultBox" *ngIf="setDepartment2">{{setDepartment2.departmentName | translate | labelSanitizer}}
                          </span>
                                                    <span class="resultBox" *ngIf="!setDepartment2">{{ 'EVALUATION.All.DEPARTMENTS' | translate }}
                          </span>
                                                    <span class="resultBox" *ngIf="setCategory2">{{setCategory2.categoryName | translate | labelSanitizer}}</span>
                                                    <span class="resultBox" *ngIf="!setCategory2">{{ 'EVALUATION.All.PROFESSIONAL_CATEGORIES' | translate }}
                          </span>
                                                    <div *ngIf="showProfessionalSubcategory">
                                                        <span class="resultBox" *ngIf="setSubCategory2">{{setSubCategory2.subCategoryName | translate | labelSanitizer}} </span>
                                                        <span class="resultBox" *ngIf="!setCategory2">{{ 'EVALUATION.All.PROFESSIONAL_SUB_CATEGORIES' | translate }} </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div class="col-12 static-card mt-2" *ngIf="printChart">
                                <!-- <h1 class="section-title">{{complianceTitle |translate}}</h1> -->
                                <lib-ph-bhp-bar-chart #chart [type]="'bar'" [maxDivisions]='10' [maxBar]='10'></lib-ph-bhp-bar-chart>
                            </div>
                            <div class="col-12 static-card mt-2" *ngFor="let childChart of childChartCount">
                                <!-- <h1 class="section-title">{{complianceTitle |translate}}</h1> -->
                                <lib-ph-bhp-bar-chart #chartList [type]="'bar'" [maxDivisions]='10' [maxBar]='10'>
                                </lib-ph-bhp-bar-chart>
                            </div>

                            <div class="col-12 static-card mt-2" *ngIf="gridData">
                                <!-- <h1 class="section-title">{{complianceTitle |translate}}</h1> -->
                                <table class="table table-border my-2" style="width: 14cm;">
                                    <thead>
                                        <tr>
                                            <th *ngFor="let field of fields">
                                                {{field.title | translate | labelSanitizer}}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let data of gridData">
                                            <td *ngFor="let field of fields">
                                                {{ data[field.field] }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div class="col-12 static-card mt-2" *ngIf="secGridData">
                                <!-- <h1 class="section-title">{{complianceTitle |translate}}</h1> -->
                                <table class="table table-border my-2" style="width: 14cm;">
                                    <thead>
                                        <tr>
                                            <th *ngFor="let field of secFields">
                                                {{field.title | translate | labelSanitizer}}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let data of secGridData">
                                            <td *ngFor="let field of secFields">
                                                {{ data[field.field] }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                        </div>
                    </div>
                </tbody>
            </table>
        </div>
        <ng-template kendoPDFTemplate let-pageNum="pageNum" let-totalPages="totalPages">
            <div class="pdf-page-template">
                <div class="pdf-heading-wrapper">
                    <div class="pdf-heading col-12">
                        <img class="app-logo" [src]="logoSrc" alt="App logo">
                        <h1 class="section-title">{{ complianceTitle | translate | labelSanitizer }}</h1>
                        <h1 class="section-title" *ngIf="complianceTitle == 'Sub-step compliance' && !subStepDetail">
                            {{ ' ( ' + ('GENERAL.WITHOUT_SUB_PROCESS' | translate) + ' )' }}</h1>
                    </div>
                </div>
                <div class="pageNum">
                    {{ 'GENERAL.PAGE'| translate }} {{ pageNum }} {{ 'GENERAL.OF' | translate }} {{ totalPages }}
                </div>
            </div>
        </ng-template>
    </kendo-pdf-export>
</div>
